//@flow
import * as React from 'react';
import {
    sidebarFactory,
    type sidebarFactoryOptions,
    type SidebarProps
} from 'common/components/core/sidebar/Sidebar';

import DefaultNavGroupTitle from './DefaultNavGroupTitle';
import { defaultSectionFactory } from './DefaultSection';
import DefaultSubSection from './DefaultSubSection';

import { routerLinkFactory } from 'common/components/core/link/RouterLink';

const NavGroupTitleWithLink = routerLinkFactory({
    LinkedComponent: DefaultNavGroupTitle
});

const NavGroupTitleWithLinkComponent = ({ source, selectable, ...others }) => {
    return selectable ? (
        <NavGroupTitleWithLink
            {...others}
            selectable={selectable}
            to={source.path}
            source={source}
        />
    ) : (
        <DefaultNavGroupTitle
            {...others}
            source={source}
            selectable={selectable}
        />
    );
};

const DefaultSectionWithLinkComponent = defaultSectionFactory({
    NavGroupTitle: NavGroupTitleWithLinkComponent
});

const DefaultSubSectionWithLink = routerLinkFactory({
    LinkedComponent: DefaultSubSection
});

const DefaultSubSectionWithLinkComponent = ({ source, ...others }) => {
    return source.path ? (
        <DefaultSubSectionWithLink
            {...others}
            to={source.path}
            source={source}
        />
    ) : (
        <DefaultSubSection source={source} {...others} />
    );
};

const sidebarWithLinkFactory = ({
    Title,
    GroupedSection = DefaultSectionWithLinkComponent,
    UngroupedSection = DefaultSectionWithLinkComponent,
    SubSection = DefaultSubSectionWithLinkComponent,
    Footer,
    options
}: sidebarFactoryOptions): React.AbstractComponent<SidebarProps> => {
    return sidebarFactory({
        Title,
        GroupedSection,
        UngroupedSection,
        SubSection,
        Footer,
        options
    });
};

export default sidebarWithLinkFactory({});
export { sidebarWithLinkFactory };
